import React from 'react';
import { Link } from 'react-router';
import style from './style.module.less';
import Footer from '../Footer';
import Frame from '../Frame';
import ListFilteredEvents from '../ListFilteredEvents';

function Content({ children, sidebar, events, soundcloud, youtube, youtubeList }) {
    return (
        <div>
            <div className={style.container}>
                <article className={style.main}>
                    {children}
                    {soundcloud ? <Soundcloud id={soundcloud} /> : null}
                    {youtube ? <Youtube id={youtube} /> : null}
                    {youtubeList ? <Youtube list={youtubeList} /> : null}
                </article>
                {sidebar || events
                    ? <aside className={style.sidebar}>
                          {events && events.length
                              ? <div>
                                    <h2>TERMINE</h2>
                                    <ListFilteredEvents events={events} />
                                </div>
                              : null}
                          {sidebar}
                      </aside>
                    : null}
            </div>
            <Footer />
        </div>
    );
}

export default Content;

function Soundcloud({ id }) {
    const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/${id}&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true`;
    return (
        <Frame className={style.media}>
            <iframe width="100%" height="450" scrolling="no" frameBorder="no" src={src} />
        </Frame>
    );
}

function Youtube({ id, list }) {
    const param = id ? id : '?listType=playlist&list=' + list;

    return (
        <Frame className={style.media} frameID={3}>
            <iframe
                width="100%"
                height="300px"
                src={'https://www.youtube-nocookie.com/embed/' + param}
                frameBorder="0"
                allowFullScreen
            />
        </Frame>
    );
}



// WEBPACK FOOTER //
// ../components/Content/index.js